module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point04_04_activity-4531dd0ac7aa56480ffee24339860880.jpg";